// const BASEURL = 'http://localhost:5000/api';  // localhost

const BASEURL = process.env.REACT_APP_API_URI;
export const S3_BUCKET_NAME = process.env.REACT_APP_S3_BUCKET_NAME;
export const AZURE_BLOB_STORAGE = process.env.REACT_APP_AZURE_STORAGE_ACCOUNT;
export const DATABASE_NAME = process.env.REACT_APP_PG_DATABASE_NAME;
export const AWS_CONFIG_TYPE = process.env.REACT_APP_AWS_CONFIG_TYPE === 'true';
export const PROFILE_ENV = process.env.REACT_APP_PROFILE_ENV || 'no_profile_env';


export const BACKEND_VDE_BASEURL = 'https://depllm.eastus.cloudapp.azure.com'; // VDE URL for deployed
export const OPEN_AI_URL = 'https://depgenopenai.eastus.cloudapp.azure.com';
export const AWS_UI_URL = 'https://nagarro.dataenterpriseplatform.click/';
export const AZURE_UI_URL = 'https://dataengplatform.com/';
export const SNOWFLAKE_UI_URL = 'http://dep-snowpark-react-frontend-env.us-east-1.elasticbeanstalk.com/';
export const ETL_COPILOT_WEB_SOCKET_URL = `wss://dep-etl-copilot.dep-ai.com/ws/etl-copilot-abc`;
export const DQ_AGENT_WEB_SOCKET_URL = `wss://dq-agent.dep-ai.com/ws/logs`;

export default BASEURL;
